export default __webpack_public_path__ + "static/media/logo.33024b48.svg";